import PropTypes from 'prop-types';

const Absence = ({ color }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.23126 1.29532C7.54597 0.665896 8.11458 3.35276e-08 9 0C9.88542 -6.70552e-08 10.454 0.665895 10.7687 1.29532C11.0935 1.94474 11.25 2.73559 11.25 3.375L11.25 7.52736L17.0672 10.4359C17.6389 10.7218 18 11.3061 18 11.9453V13.5C18 13.6653 17.9272 13.8223 17.8011 13.9292C17.6749 14.0361 17.5081 14.082 17.345 14.0548L11.1499 13.0223L10.7274 15.5569L12.2102 17.0398C12.3711 17.2006 12.4192 17.4426 12.3322 17.6528C12.2451 17.863 12.04 18 11.8125 18L6.1875 18C5.95999 18 5.75488 17.863 5.66782 17.6528C5.58075 17.4426 5.62888 17.2006 5.78975 17.0398L7.27256 15.5569L6.85013 13.0223L0.654974 14.0548C0.491876 14.082 0.325078 14.0361 0.198914 13.9292C0.0727501 13.8223 0 13.6653 0 13.5L0 11.9453C0 11.3061 0.361128 10.7218 0.932827 10.4359L6.75 7.52736V3.375C6.75 2.73559 6.90655 1.94474 7.23126 1.29532ZM8.23749 1.79843C7.9997 2.27401 7.875 2.88941 7.875 3.375V7.875C7.875 8.08806 7.75462 8.28283 7.56406 8.37812L1.43594 11.4422C1.24538 11.5375 1.125 11.7322 1.125 11.9453V12.836L7.22003 11.8202C7.52646 11.7691 7.81627 11.9761 7.86735 12.2825L8.42985 15.6575C8.45971 15.8367 8.4012 16.0193 8.27275 16.1477L7.5455 16.875H10.4545L9.72725 16.1477C9.5988 16.0193 9.54029 15.8367 9.57015 15.6575L10.1327 12.2825C10.1837 11.9761 10.4735 11.7691 10.78 11.8202L16.875 12.836V11.9453C16.875 11.7322 16.7546 11.5375 16.5641 11.4422L10.4359 8.37812C10.2454 8.28283 10.125 8.08806 10.125 7.875L10.125 3.375C10.125 2.88941 10.0003 2.27401 9.76251 1.79843C9.51472 1.30285 9.23958 1.125 9 1.125C8.76042 1.125 8.48528 1.30285 8.23749 1.79843Z"
      fill={color}
    />
  </svg>
);

Absence.propTypes = {
  color: PropTypes.string,
};

Absence.defaultProps = {
  color: '#696F7C',
};

export default Absence;
